<template>
  <div class="mobile-cart" :class="{'is-active': active}" v-click-outside="close">
    <transition name="animation-popper-fade">
      <div class="mobile-cart__popper" v-show="active">
        <div class="mobile-cart__scroll">
          <template v-if="Object.keys(stateCartItems).length">
            <ul class="mobile-cart__list">
              <li v-for="(item, name) in itemsSort" :key="item.id" class="mobile-cart__item">
                <div v-if="item">
                  <span
                    class="mobile-cart__link mobile-cart__inner"
                    :class="[Number($route.params.order) === Number(item.page.order) ? 'is-exact-active' : '']"
                    v-if="Number(item.page.order) <= 2"
                    @click="warningDialog(item)">
                    <span class="mobile-cart__name">{{ item.name }}</span>
                    <span v-show="item.priceIncTax" class="mobile-cart__price">{{ item.priceIncTax | price }} 円</span>
                  </span>
                  <router-link
                    class="mobile-cart__link mobile-cart__inner"
                    v-else
                    :to="{
                      path: [$route.path.match(/gogatsu/) ?  config.path.root_gogatsu : config.path.root] + '/step/' + item.page.slug + '/' + item.page.order,
                      query: $route.query,
                    }"
                    exact>
                    <span class="mobile-cart__name">{{ item.name }}</span>
                    <span v-show="item.priceIncTax" class="mobile-cart__price">{{ item.priceIncTax | price }} 円</span>
                  </router-link>
                  <div v-show="item.priceIncTax" class="mobile-cart__line"></div>
                </div>
              </li>
            </ul>
            <div class="mobile-cart__total-price">
              <span class="mobile-cart__total-price__title">合計金額</span>
              <span>
                <span class="mobile-cart__total-price__num">{{ stateCartTotalPrice | price }}</span>
                <span class="mobile-cart__total-price__unit">円</span>
              </span>
            </div>
          </template>
          <div v-else class="mobile-cart__no-item">カートに商品はありません。</div>
        </div>
      </div>
    </transition>

    <button
      class="mobile-cart__button"
      :class="{'is-add': button.add}"
      @click="buttonClick()">
      <img class="mobile-cart__button-icon" src="/choice/img/icon/cart-white.svg" alt="">
    </button>

    <v-prev-dialog v-model="dialog.state" message="サイズ、人数へ戻ると今まで選択した商品がリセットされます。"/>
  </div>
</template>



<script>
import { mapState } from 'vuex'
import ClickOutside from 'vue-click-outside'

export default {
  components: {
    'v-prev-dialog': require('@/components/prev-dialog.vue').default,
  },
  computed: {
    ...mapState({
      stateCartTotalPrice: state => state.cart.totalPrice,
      stateCartItems: state => state.cart.items,
    }),
    itemsSort() {
      let val = JSON.parse(JSON.stringify(this.stateCartItems))
      let sorted = {}
      let array = []

      Object.keys(val).forEach((key) => {
        if (val.hasOwnProperty(key)) {
          array.push(key)
        }
      })

      array.sort((a, b) => {
        a = Number(val[a].page.order)
        b = Number(val[b].page.order)

        if (a < b) {
          return -1
        } else if (a > b){
          return 1
        }
        return 0;
      })

      for (let i=0; i<array.length; i++) {
        sorted[array[i]] = this.stateCartItems[array[i]]
      }

      let num = 0
      for(let key in this.stateCartItems) {
        if (this.stateCartItems[key].price) {
          num = num + 1
          if (this.quantity < num) {
            console.log('test');
            this.$set(this.button, 'add', true)
            setTimeout(() => {
              this.$set(this.button, 'add', false)
            }, 1000)
          }
          this.quantity = num
        }
      }

      return sorted
    },
  },
  data() {
    return {
      quantity: 0,
      button: {
        add: false
      },
      active: false,
      dialog: {
        state: false,
      },
    }
  },
  methods: {
    warningDialog(item) {
      if (Number(this.$route.params.order) === Number(item.page.order)) {
        return
      } else if (Number(this.$route.params.order) < 3) {
        this.$router.push({
          path: this.config.path.root + '/step/sizes/1',
          query: '',
        })
      } else {
        this.$set(this.dialog, 'state', true)
      }
    },
    close() {
      this.active = false
    },
    buttonClick() {
      if (this.active) {
        this.active = false
      } else {
        this.active = true
      }
    }
  },
  filters: {
    price(val) {
      if (!val) return

      val = String(val)
      val = val.replace(/,/g, '')
      val = Number(val)
      val = val.toLocaleString()
      val = val.toString()

      return val
    },
  },
  directives: {
    ClickOutside
  }
}
</script>



<style lang="scss">
.mobile-cart {
  $e: &;
  position: relative;
  &.is-active {
  }

  &__button {
    display: flex;
    justify-content: center;
    align-items: center;
    transition: $transition;
    border-radius: 50%;
    cursor: pointer;
    appearance: none;
    box-shadow: 0 6px 8px rgba(#000, 0.1);
    outline: none;
    border: none;
    background-color: $accent-color;
    width: 54px;
    height: 54px;
    padding: 0;
    @include active() {
      box-shadow: 0 4px 8px rgba(#000, 0.1), 0 4px 16px rgba(#000, 0.3);
    }
    &.is-add {
      animation: bounce 1.0s ease 0s 1;
      @keyframes bounce {
        0%   { transform: scale(1, 1)}
        10%  { transform: scale(1.1, .9)}
        30%  { transform: scale(.9, 1.1); margin-top: -32px;}
        50%  { transform: scale(1.1,1); margin-top: 0;}
        57%  { transform: scale(1.1,1); margin-top: -8px;}
        64%  { transform: scale(1,1)}
        100% { transform: scale(1,1)}
      }
    }
  }
  &__button-icon {
    display: block;
    width: 18px;
  }

  &__list {
  }
  &__item {
    position: relative;
  }
  &__inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    text-align: center;
    border-radius: 3px;
    padding: 6px 12px;
  }
  &__link {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    transition: $transition;
    position: relative;
    border-radius: 3px;
    font-size: 12px;
    color: $oc-gray-9;
  }
  &__name {
    display: inline-block;
    transition: $transition;
    position: relative;
    z-index: 2;
    background-color: #fff;
    padding-right: 20px;
  }
  &__price {
    display: inline-block;
    z-index: 2;
    transition: $transition;
    background-color: #fff;
    padding-left: 20px;
  }
  &__line {
    position: absolute;
    top: 50%;
    left: 12px;
    z-index: 1;
    border-top: 2px dotted $oc-gray-5;
    width: calc(100% - 24px);
    height: 0;
  }
  &__total-price {
    display: flex;
    justify-content: space-between;
    border-radius: 4px;
    background-color: $oc-gray-2;
    margin-left: 12px;
    margin-right: 12px;
    margin-top: 14px;
    padding: 16px 20px;
    &__title {
    }
    &__num {
    }
    &__unit {
      margin-left: 4px;
    }
  }
  &__no-item {
    text-align: center;
    padding-top: 16px;
    padding-bottom: 16px;
  }

  &__popper {
    display: block;
    position: absolute;
    bottom: 72px;
    left: 50%;
    transform: translateX(-50%);
    width: 100vw;
    max-width: 448px;
    padding-left: 16px;
    padding-right: 16px;
    &::after {
      content: "";
      position: absolute;
      bottom: -7px;
      left: 50%;
      transform: translateX(-50%);
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-top: 7px solid #fff;
    }
    &.animation-popper-fade {
      &-enter {
        opacity: 0;
        bottom: 56px;
      }
      &-enter-to {
        opacity: 1;
        bottom: 72px;
      }
      &-leave {
        opacity: 1;
      }
      &-leave-to {
        opacity: 0;
      }
      &-enter-active {
        transition: 0.4s ease-out;
      }
      &-leave-active {
        transition: 0.2s ease-in;
      }
    }
  }
  &__scroll {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    transition: $transition;
    box-shadow: 0 8px 17px 2px rgba(#000, 0.07), 0 3px 14px 2px rgba(#000, 0.06), 0 5px 5px -3px rgba(#000, 0.1);
    border-radius: 6px;
    background-color: #fff;
    width: 100%;
    max-height: calc(100vh - 214px);
    padding: 20px 16px;
  }
}

.app-gogatsu {
    .mobile-cart {
        &__button {
            background-color: $gogatsu-accent-color;
        }
    }
}
</style>
